import React, {useEffect, useState} from "react";
import {ConditionDtoTypeEnum} from "../../../../api";
import {Collapse, Input, Select, Form} from "antd";
import {getLabelWithNameAndInfotext} from "../../../../utils/Utils";

const {Option} = Select;
const {Panel} = Collapse;

type PrefabCommandOptionComponentProps = {
    form: any; // Form API von Ant Design
};

// Hilfsfunktion zur Erstellung von Form-Items
const renderFormItem = (key: string, name: string, label: React.ReactNode, placeholder: string, form: any) => (
    <Form.Item key={key} name={name} label={label}>
        <Input
            placeholder={placeholder}
            onChange={(e) => form.setFieldValue(name, e.target.value)}
        />
    </Form.Item>
);

const PrefabCommandOptionComponent: React.FC<PrefabCommandOptionComponentProps> = ({form}) => {
    const [currentOption, setCurrentOption] = useState<ConditionDtoTypeEnum | undefined>(undefined);

    const conditionTypeNames = {
        None: 'Keine Auswahl',
        [ConditionDtoTypeEnum.Exists]: 'Variable existiert',
        [ConditionDtoTypeEnum.NotExists]: 'Variable existiert nicht',
        [ConditionDtoTypeEnum.Equals]: 'Variable gleich',
        [ConditionDtoTypeEnum.NotEquals]: 'Variable ungleich'
    };

    useEffect(() => {
        const conditionType = form.getFieldValue('conditionType');
        if (conditionType) {
            setCurrentOption(conditionType);
        }
    }, [form])

    const updateCurrentOption = (value) => {
        let option = value === 'None' ? undefined : (value as ConditionDtoTypeEnum);
        setCurrentOption(option);
        form.setFieldValue('conditionType', option);
    }

    // Funktion zum Rendern der Eingabefelder je nach Auswahl
    const renderInputFields = () => {
        const currentOption = form.getFieldValue('conditionType');

        if (!currentOption) return null;

        switch (currentOption) {
            case ConditionDtoTypeEnum.Exists:
                return renderFormItem(
                    "conditionExists",
                    "conditionExists",
                    "Variable",
                    "Geben Sie den Wert für 'Exists' ein",
                    form
                );

            case ConditionDtoTypeEnum.NotExists:
                return renderFormItem(
                    "conditionNotExists",
                    "conditionNotExists",
                    "Variable",
                    "Geben Sie den Wert für 'Not Exists' ein",
                    form
                );

            case ConditionDtoTypeEnum.Equals:
                return (
                    <>
                        {renderFormItem(
                            "conditionEqualsVar",
                            "conditionEqualsVar",
                            getLabelWithNameAndInfotext('Variable', 'Einen Variablennamen ohne {}'),
                            "Geben Sie eine Variable an",
                            form
                        )}
                        {renderFormItem(
                            "conditionEqualsValue",
                            "conditionEqualsValue",
                            getLabelWithNameAndInfotext('Wert', 'Es kann auch ein weiterer Wert einer anderen Variable verglichen werden', 'Nutze dazu {Variablenname}'),
                            "Geben Sie einen Vergleichswert an",
                            form
                        )}
                    </>
                );

            case ConditionDtoTypeEnum.NotEquals:
                return (
                    <>
                        {renderFormItem(
                            "conditionNotEqualsVar",
                            "conditionNotEqualsVar",
                            getLabelWithNameAndInfotext('Variable', 'Einen Variablennamen ohne {}'),
                            "Geben Sie eine Variable an",
                            form
                        )}
                        {renderFormItem(
                            "conditionNotEqualsValue",
                            "conditionNotEqualsValue",
                            getLabelWithNameAndInfotext('Wert', 'Es kann auch ein weiterer Wert einer anderen Variable verglichen werden', 'Nutze dazu {Variablenname}'),
                            "Geben Sie einen Vergleichswert an",
                            form
                        )}
                    </>
                );

            default:
                return null;
        }
    };

    return (
        <Collapse>
            <Panel header="Weitere Einstellungen (optional)" key="1">
                {/* Dropdown zur Auswahl der Option */}
                <Form.Item name="conditionType" label="Bedingung">
                    <Select
                        placeholder="Wählen Sie eine Option"
                        value={currentOption}
                        onChange={updateCurrentOption}
                        style={{width: '100%', marginBottom: '16px'}}
                    >
                        {Object.entries(conditionTypeNames).map(([key, label]) => (
                            <Option key={key} value={key}>
                                {label}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>

                {/* Eingabefelder abhängig von der Auswahl */}
                {renderInputFields()}
            </Panel>
        </Collapse>
    );
};

export default PrefabCommandOptionComponent;
